import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  heading: string;
  bullets: string[];
}

export const CheckoutDisclaimer: React.FC<Props> = ({ heading, bullets }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3 text-body-14 text-subtle-foreground">
      <div className="flex flex-col gap-1">
        <p className="text-subhead-14">{heading}</p>
        <ul className="flex list-disc flex-col gap-1 pl-5">
          {bullets.map((bullet, index) => (
            <li key={index}>{bullet}</li>
          ))}
        </ul>
      </div>
      <p className="whitespace-pre-line">
        {t('subscription.checkout.provider')}
      </p>
    </div>
  );
};
